<template>
  <div class="left_block my-notifications">
    <p class="header">Уведомления</p>

    <NotificationsFilter @delete-all="deleteAll" :rows="rows" :search="search" @delete="deleteChecked" />

    <NotificationsList
      @delete="deleteNotification"
      @open="openCourse"
      :rows="rows"
      :is-loading="isLoading"
      :notifications-list="notificationsList"
    />
  </div>
</template>

<script>
import NotificationsFilter from '@/components/user/my-notifications/NotificationsFilter'
import NotificationsList from '@/components/user/my-notifications/NotificationsList'
import { toastInfo } from '@/lib/toastCfg'

export default {
  components: {
    NotificationsList,
    NotificationsFilter
  },
  data() {
    return {
      isLoading: true,
      rows: {
        checked: []
      },
      search: {
        text: ''
      }
    }
  },
  computed: {
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    notificationsList() {
      return this.$store.state.notifications.notificationsList
    }
  },
  methods: {
    loadData() {
      this.$axios2
        .get('notifications?unread')
        .then((resp) => {
          this.$store.commit('setNotificationsList', { list: resp.data })
          this.$store.commit('setUnreadNotificationsList', { list: resp.data })
        })
        .catch(this.$errorToast)
        .finally(() => {
          this.isLoading = false
        })
    },
    openCourse(courseId) {
      this.$router.push('course-info/' + courseId)
    },
    deleteNotification(not) {
      this.$axios2
        .post('notifications', { notifications: [not.id] })
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadData()
        })
        .catch(this.$errorToast)
    },
    deleteChecked() {
      let data = []
      this.rows.checked.forEach((not) => {
        data.push(not.id)
      })
      this.$axios2
        .post('notifications', { notifications: data })
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.rows.checked = []
          this.loadData()
        })
        .catch(this.$errorToast)
    },
    deleteAll() {
      this.$axios2
        .post('notifications', { notifications: [] })
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.loadData()
        })
        .catch(this.$errorToast)
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>
